// @ts-nocheck
// Greif UI Kit = line-quick-order
import * as React from "react";

const PowerBolt: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m10.55 18.2 5.175-6.2h-4l.725-5.675L7.825 13H11.3zM9 15H5.9q-.6 0-.888-.537-.287-.538.063-1.038l7.475-10.75q.25-.35.65-.487.4-.138.825.012t.625.525.15.8L14 10h3.875q.65 0 .913.575.261.575-.163 1.075L10.4 21.5a1.27 1.27 0 0 1-.675.425 1.13 1.13 0 0 1-.775-.075 1.3 1.3 0 0 1-.588-.538 1.23 1.23 0 0 1-.162-.787z"
            />
        </svg>
    );
};

export default React.memo(PowerBolt);
